import { handleMultipleFields, handlePathToQuery } from '@spa/shared/utils/queryParams';
import { ALLOWANCE_RULES } from '@spa/shared/constants/allowanceRules';
import { PROPERTY_TYPE_CODE } from '@spa/shared/constants/propertyType';
import { PURPOSE_OF_STAY_TYPES } from '@spa/shared/constants/purposeOfStay';
import { RENT_TYPE } from '@spa/shared/constants/rentType';
import { GENDER_RESTRICTIONS } from '@spa/shared/constants/genderRestrictions';
import { SORTING_OPTIONS } from '@spa/shared/constants/sortingOptions';

const { FEMALE_ROOM, MALE_ROOM, FEMALE_PROPERTY, MALE_PROPERTY } = GENDER_RESTRICTIONS;

export const getSearchQuery = query => ({ ...handleMultipleFields(query), ...handlePathToQuery(query.city) });

export const getSearchQueryMetadata = searchQuery => {
  const rentTypeParam = searchQuery['rent-type'];
  const hasEntireProperty = rentTypeParam?.includes(RENT_TYPE.ENTIRE_PROPERTY) ?? false;
  const hasBedroom = rentTypeParam?.includes(RENT_TYPE.BEDROOM) ?? false;
  const hasBed = rentTypeParam?.includes(RENT_TYPE.BED) ?? false;

  const bedroomsCount = searchQuery['bedrooms'] ? Number(searchQuery['bedrooms']?.[0]) : 0;
  const hasStudio = hasEntireProperty && bedroomsCount === 1;

  const hasStudentResidence = searchQuery['housing-type']?.includes(PROPERTY_TYPE_CODE.RESIDENCE) ?? false;

  const rentTypesCount = rentTypeParam?.length ?? 0;
  const rentTypesAndStudentResidenceCount = rentTypesCount + (hasStudentResidence ? 1 : 0);

  const occupationRestrictionsParam = searchQuery['restrictions-occupation'];
  const isSuitableForProfessionals =
    occupationRestrictionsParam?.includes(PURPOSE_OF_STAY_TYPES.PROFESSIONAL_PLACEMENT) ?? false;
  const isSuitableForUndergraduates =
    occupationRestrictionsParam?.includes(PURPOSE_OF_STAY_TYPES.UNDERGRADUATE) ?? false;
  const isSuitableForPostgraduates = occupationRestrictionsParam?.includes(PURPOSE_OF_STAY_TYPES.POSTGRADUATE) ?? false;
  const isSuitableForStudents = isSuitableForUndergraduates || isSuitableForPostgraduates;
  const hasOccupationRestrictions = isSuitableForProfessionals || isSuitableForStudents;

  const genderRestrictionsParam = searchQuery['restrictions-gender'];
  const isSuitableForFemales = genderRestrictionsParam === FEMALE_ROOM;
  const isSuitableForMales = genderRestrictionsParam === MALE_ROOM;
  const isSuitableForFemalesOnly = genderRestrictionsParam === FEMALE_PROPERTY;
  const isSuitableForMalesOnly = genderRestrictionsParam === MALE_PROPERTY;
  const hasGenderRestrictions =
    isSuitableForFemales || isSuitableForMales || isSuitableForFemalesOnly || isSuitableForMalesOnly;
  const isGenderExclusive = isSuitableForFemalesOnly || isSuitableForMalesOnly;

  const hasPetsAllowed = searchQuery['rules']?.includes(ALLOWANCE_RULES.PETS_ALLOWED) ?? false;

  const houseFeaturesCount = searchQuery['property-features']?.length ?? 0;
  const houseFeaturesAndPetsAllowedCount = houseFeaturesCount + (hasPetsAllowed ? 1 : 0);

  const isSortingByAscendingPrices = searchQuery['order'] === SORTING_OPTIONS.PRICE_ASC;

  return {
    hasEntireProperty,
    hasBedroom,
    hasBed,
    hasStudio,
    hasStudentResidence,

    isSuitableForProfessionals,
    isSuitableForUndergraduates,
    isSuitableForPostgraduates,
    isSuitableForStudents,
    hasOccupationRestrictions,

    isSuitableForFemales,
    isSuitableForMales,
    isSuitableForFemalesOnly,
    isSuitableForMalesOnly,
    hasGenderRestrictions,
    isGenderExclusive,

    hasPetsAllowed,

    bedroomsCount,

    rentTypesCount,
    rentTypesAndStudentResidenceCount,

    houseFeaturesCount,
    houseFeaturesAndPetsAllowedCount,

    isSortingByAscendingPrices
  };
};
